import React from 'react';

function ServerConfig({ data, onChange }) {
  const handleChange = (field, value, nested = null) => {
    const newData = { ...data };
    if (nested) {
      newData[nested] = { ...newData[nested], [field]: value };
    } else {
      newData[field] = value;
    }
    onChange(newData);
  };

  return (
    <div className="row g-4">
      <div className="col-lg-6">
        <div className="card h-100 border-0 shadow-sm">
          <div className="card-header bg-primary bg-opacity-10 border-0">
            <h5 className="card-title mb-0 text-primary">
              <i className="bi bi-server me-2"></i>
              Server Configuration
            </h5>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <label className="form-label fw-semibold">
                <i className="bi bi-hdd-network me-1"></i>
                Host
              </label>
              <input 
                type="text" 
                className="form-control form-control-lg" 
                placeholder="e.g., localhost or 0.0.0.0"
                value={data.bind?.host || ''} 
                onChange={(e) => handleChange('host', e.target.value, 'bind')}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">
                <i className="bi bi-ethernet me-1"></i>
                Port
              </label>
              <input 
                type="number" 
                className="form-control form-control-lg" 
                placeholder="e.g., 5000"
                value={data.bind?.port || ''} 
                onChange={(e) => handleChange('port', parseInt(e.target.value), 'bind')}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">
                <i className="bi bi-link-45deg me-1"></i>
                URL
              </label>
              <input 
                type="url" 
                className="form-control form-control-lg" 
                placeholder="https://example.com/api"
                value={data.url || ''} 
                onChange={(e) => handleChange('url', e.target.value)}
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">
                <i className="bi bi-translate me-1"></i>
                Language
              </label>
              <select 
                className="form-select form-select-lg"
                value={data.language || ''} 
                onChange={(e) => handleChange('language', e.target.value)}
              >
                <option value="">Select language</option>
                <option value="en-US">English (US)</option>
                <option value="en-GB">English (UK)</option>
                <option value="fr-FR">French</option>
                <option value="de-DE">German</option>
                <option value="es-ES">Spanish</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      
      <div className="col-lg-6">
        <div className="card h-100 border-0 shadow-sm">
          <div className="card-header bg-success bg-opacity-10 border-0">
            <h5 className="card-title mb-0 text-success">
              <i className="bi bi-gear me-2"></i>
              Server Options
            </h5>
          </div>
          <div className="card-body">
            <div className="row g-3">
              <div className="col-12">
                <div className="form-check form-switch">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="corsSwitch"
                    checked={data.cors || false}
                    onChange={(e) => handleChange('cors', e.target.checked)}
                  />
                  <label className="form-check-label fw-semibold" htmlFor="corsSwitch">
                    <i className="bi bi-shield-check me-1"></i>
                    Enable CORS
                  </label>
                  <div className="form-text">Allow cross-origin requests</div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="adminSwitch"
                    checked={data.admin || false}
                    onChange={(e) => handleChange('admin', e.target.checked)}
                  />
                  <label className="form-check-label fw-semibold" htmlFor="adminSwitch">
                    <i className="bi bi-person-gear me-1"></i>
                    Enable Admin
                  </label>
                  <div className="form-text">Enable administrative features</div>
                </div>
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold">
                  <i className="bi bi-list-ol me-1"></i>
                  Default Items
                </label>
                <input 
                  type="number" 
                  className="form-control form-control-lg" 
                  placeholder="e.g., 10"
                  value={data.limits?.default_items || ''} 
                  onChange={(e) => handleChange('default_items', parseInt(e.target.value), 'limits')}
                />
                <div className="form-text">Default number of items per page</div>
              </div>
              <div className="col-12">
                <label className="form-label fw-semibold">
                  <i className="bi bi-list me-1"></i>
                  Max Items
                </label>
                <input 
                  type="number" 
                  className="form-control form-control-lg" 
                  placeholder="e.g., 1000"
                  value={data.limits?.max_items || ''} 
                  onChange={(e) => handleChange('max_items', parseInt(e.target.value), 'limits')}
                />
                <div className="form-text">Maximum number of items per page</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServerConfig;